import React, { useState } from "react";
import firebase from "firebase/app";
import { useHistory } from "react-router-dom";
import Mensaje from "../../Mensaje";
import { dbApp } from "../../../firebase/config";

const AgregarPromocion = () => {
  const [img, setImg] = useState("");
  const [mensaje, setMensaje] = useState("");

  let history = useHistory();

  const STATE_INICIAL = {
    titulo: "",
    descripcion: "",
    images: "",
    estatus: ""
  };

  const [datosForm, setDatosForm] = useState(STATE_INICIAL);

  const handleChange = e => {
    setDatosForm({
      ...datosForm,
      [e.target.name]: e.target.value.toUpperCase()
    });
  };

  const handleUpload = event => {
    const file = event.target.files[0];
    const storeRef = firebase.storage().ref(`images/${file.name}`);
    const task = storeRef.put(file);

    task.on(
      "state_changed",
      snapshot => {
        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("Upload is " + progress + "% done");
      },
      error => {
        console.log("Ocurrio un error al subir las imagenes.");
      },
      () => {
        task.snapshot.ref.getDownloadURL().then(function(downloadURL) {
          console.log("File available at", downloadURL);
          setImg(downloadURL);
          setDatosForm({
            ...datosForm,
            images: downloadURL
          });
        });
      }
    );
  };

  const hanldeSubmit = () => {
    if (
      datosForm.titulo === "" ||
      datosForm.descripcion === "" ||
      datosForm.ubicacion === ""
    ) {
      setMensaje("Favor de llenar la infomación.");
    } else if (datosForm.images === "") {
      setMensaje("Favor de seleccionar imagen del producto.");
    } else {
      dbApp
        .collection("promociones")
        .add(datosForm)
        .then(response => {
          history.push("/admin/promocion");
        })
        .catch(() => {
          console.log("Erro");
        });
    }
  };

  return (
    <>
      <form>
        <div className="form-group">
          <label htmlFor="titulo">Titulo</label>
          <input
            type="text"
            className="form-control"
            id="titulo"
            name="titulo"
            value={datosForm.titulo}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="descripcion">Descripción</label>
          <input
            type="text"
            className="form-control"
            id="descripcion"
            name="descripcion"
            value={datosForm.descripcion}
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label htmlFor="estatus">Estatus</label>
          <select
            className="form-control"
            id="estatus"
            name="estatus"
            value={datosForm.estatus}
            onChange={handleChange}
          >
            <option>Selecciona...</option>
            <option value="1">ACTIVO</option>
            <option value="0">INACTIVO</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="imagen">Imagen</label>
          <br />
          {img ? (
            <div className="w-100 mt-1 mb-1 border" style={{ height: "100px" }}>
              <img className="rounded w-50 h-100 border" src={img} alt="IMG" />
            </div>
          ) : null}
          <span className="btn btn-primary btn-file">
            <i className="fa fa-upload" aria-hidden="true"></i>
            <input
              type="file"
              id="images"
              name="images"
              multiple
              accept="image/*"
              onChange={handleUpload}
            />
          </span>
        </div>

        <div className="d-flex justify-content-end mt-4">
          <button
            type="button"
            className="btn btn-primary mr-2"
            onClick={hanldeSubmit}
          >
            <i className="fa fa-plus mr-1" aria-hidden="true"></i>
            Agregar Promocion
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => history.goBack()}
          >
            <i className="fa fa-chevron-left mr-1" aria-hidden="true"></i>
            Cancelar
          </button>
        </div>

        {mensaje && (
          <div className="mt-2">
            <Mensaje mensaje={mensaje} />
          </div>
        )}
      </form>
    </>
  );
};

export default AgregarPromocion;
